import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 1rem;
  & > h3 {
    font-weight: bold;
    margin-bottom: 2rem;
    font-size: 1rem;
  }
  .subtitle {
    color: ${({ theme }) => theme.colors.grayDark4};
  }
  .mdc-chip--selected {
    cursor: default;
    pointer-events: none;
  }
`;

export const ModalOverride = styled.div`
  .hefesto-title h3 {
    color: ${({ theme }) => theme.colors.grayDark3};
    margin-bottom: 12px;
  }
  .hefesto-modal__header {
    margin-bottom: 0;
  }

  .hefesto-modal__body {
    margin-bottom: 0px;
  }

  .hefesto-modal__body > div:first-child {
    gap: 1.5rem;
  }

  .mdc-chip-set {
    padding-left: 0;
    padding-top: 0;
  }

  .mdc-chip-set .mdc-chip .mdc-chip__text {
    margin-right: 0;
  }

  .hefesto-chip .mdc-chip {
    border-width: 1px;
    padding: 16px;
    margin-left: -2px;
    margin-right: 16px;
    padding: 15px 7px 16px 12px;
    letter-spacing: 0.2px;
  }

  .hefesto-chip .mdc-chip.mdc-chip--selected {
    pointer-events: none;
    padding-right: 9px;
  }

  .mdc-chip-set .mdc-chip {
    margin-right: 22px;
  }

  .hefesto-checkbox {
    gap: 0.925rem;
  }

  .hefesto-checkbox__item-check {
    transform: scale(2);
  }

  .hefesto-modal__body {
    overflow: inherit;
  }

  .hefesto-input-wrapper__label-wrapper__label {
    padding-left: 17px;
  }

  .hefesto-textfield input {
    padding-left: 15px;
  }

  .hefesto-modal__body > div > div:nth-child(4) > span {
    padding-top: 0;
  }
  .hefesto-modal__body > div > div:nth-child(4) > div {
    padding-top: 0.5rem;
    width: 10.2rem;
  }

  .hefesto-modal__footer {
    gap: 15px;
  }

  .hefesto-button {
    max-height: 2.5rem;
  }
`;

export const CheckBoxContainer = styled.div`
  > span {
    display: inline-block;
    font-size: 1.25rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
    line-height: 1.75rem;
  }
  > div {
    padding-left: 0.5rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    gap: 6px;
  }
`;

export const ChipsContainer = styled.div`
  display: grid;
  gap: 1rem;

  margin-bottom: 0.5rem;
  > span {
    font-size: 1.25rem;
    color: ${({ theme }) => theme.colors.grayDark4};
  }

  > div {
    padding-left: 0.1rem;
  }
`;

export const Title = styled.span<{ bold?: boolean; isTitle?: boolean }>`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.grayDark3};
`;
